module.exports = __webpack_public_path__ + "static/media/intel.bc58c045.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/intel.png
// module id = 118
// module chunks = 0